import '../layouts/ansysoft.css';
import rightArrow from '../assets/right-arrow.svg';
import faqtext from '../assets/faqtext.webp';
import faqArrow from '../assets/faq-arrow.svg';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Footer from '../components/footer';

function Faq() {


    const [activeFAQ, setActiveFAQ] = useState(null);

    const toggleFAQ = (faqId) => {
        setActiveFAQ(activeFAQ === faqId ? null : faqId);
        // const img = document.getElementsByTagName('img');
        // img.style.transform = 'rotate(180deg)';

    };

    const faqs = [
        {
            id: 1,
            question: "Why is WebBull the best platform to grow?",
            answer: (
                <>
                    <b>Unleash the Power of Rewards:</b>
                    Beyond Cryptocurrency Rates: Reward sustainability uninfluenced.<br />
                    Entry Made Simple: Minimum threshold, merely the cost of a few cups of coffee.<br />
                    Instantaneous Payouts: No waiting, funds transferred directly to your wallet.<br />
                    Action-Based Rewards: Solely dependent on participant's engagements.<br />
                    Limitless Potential: Unlock indefinite rewards by expanding your team.
                </>
            )
        },
        {
            id: 2,
            question: "Is WebBull safe?",
            answer: (
                <>The functioning of WebBull is fully blockchain-protected. Participant leaves no personal data and has only his cryptocurrency wallet address connected via WEB 3.0 technology as a login. The entire WebBull infrastructure is built on the operation of tamper-proof smart contracts, and the website is simply a projection of data from the blockchain. It makes no sense to hack into the website.</>
            )
        },
        {
            id: 3,
            question: "How much does it cost to become a community member?",
            answer: (<> There is no cost required to become a member of our community. The signup process is completely free. However, if you want to become an entrepreneur, there is a joining fee of 50 BUSD. </>)
        },
        {
            id: 4,
            question: "What do I need to get started in WebBull?",
            answer: (<>  No special knowledge is required. Every member must have their own smartphone or laptop to access our website. To register, you need to have at least a minimum amount - 50 BUSD, if you don't have, our exchange service will provide you.</>)
        },
        {
            id: 5,
            question: "How do I start?",
            answer: (<> Register on the website to gain access to the WebBull JAP and Community. Study the instructions, guides and articles on marketing so you're ready to go. </>)
        },
        {
            id: 6,
            question: "Where will my profit come from?",
            answer: (<> All earnings to your account will only come from the activity of other members who join our community. WebBull does not charge any annual fees. </>)
        },
        {
            id: 7,
            question: "Do you work with Bitcoin?",
            answer: (<> At this moment we are working with only BUSD. </>)
        },
    ];


    return (
        <>
            <div className="w-100 banner-bg-faq">
                <div className="banner-bg-1-faq">
                    <div className="container banner-wrap">
                        <div className="banner">
                            <h1 className="heading-1-faq">KNOW YOUR QUERIES</h1>
                            <p className="description-1-faq mt-2 mt-md-4">Uncover Answers, Empower Understanding: Your <span>FAQ Guide</span> to Clarity and Knowledge.</p>
                            <Link to="/signin" className="btn-main scnd-width  btn-outline-main margin-l">
                                JOIN NOW
                                <img src={rightArrow} alt="===>" width="36" height="100%" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-100 faq-bg">
                <img src={faqtext} alt="Frequently Asked Questions" className="faq-img" />
                <div className="direction-line"></div>
                <div className="faq-wrap">
                    <div className="container faq">
                        {faqs.map((faq) => (
                            <div
                                key={faq.id}
                                onClick={() => toggleFAQ(faq.id)}
                                className={`faq-box ${activeFAQ === faq.id ? "active" : ""}`}
                            >
                                <div className="faq-question-wrap">
                                    <h3 className="faq-no">{faq.id}</h3>
                                    <h3 className="faq-question">{faq.question}</h3>
                                    <button
                                        type="button"

                                        className="faq-btn"
                                    >
                                        <img className={`${activeFAQ === faq.id ? "active" : ""}`} src={faqArrow} alt="Toggle FAQ" />
                                    </button>
                                </div>
                                <div
                        className={`faq-answer-wrapper ${
                            activeFAQ === faq.id ? "open" : "closed"
                        }`}
                    >
                        <p className="faq-answer">{faq.answer}</p>
                    </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default Faq;